import React from "react";

interface JerseyIconProps {
  number: number | string | undefined;
  name: string | undefined;
  width?: number;
  height?: number;
  jerseyColor?: string;
  numberColor?: string;
  onClick?: () => void;
  selected?: boolean;
}

const JerseyIcon: React.FC<JerseyIconProps> = ({
  number,
  name,
  width = 100,
  height = 100,
  jerseyColor = "#ffffff",
  numberColor = "#222222",
  onClick,
  selected = false,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    style={{ 
      cursor: onClick ? 'pointer' : 'default',
      filter: selected ? 'drop-shadow(0 0 8px rgba(0, 0, 0, 0.3))' : 'none',
      transform: selected ? 'scale(1.05)' : 'scale(1)',
      transition: 'all 0.2s ease-in-out'
    }}
  >
    {/* Jersey shape */}
    <path
      d="M10 30 Q20 10 40 10 H80 Q100 10 110 30 L100 50 V110 H20 V50 L10 30"
      fill={selected ? "rgba(123, 45, 58, 0.9)" : jerseyColor}
      stroke={selected ? "#1976d2" : "#222"}
      strokeWidth={selected ? "4" : "3"}
    />
    {/* Jersey number */}
    <text
      x="60"
      y="80"
      textAnchor="middle"
      fontSize="48"
      fontWeight="bold"
      fill={selected ? "rgba(249, 246, 246, 0.9)" : numberColor}
      fontFamily="Arial, sans-serif"
      dominantBaseline="middle"
    >
      {number}
    </text>
    {/* Player name */}
    {name && (
      <text
        x="60"
        y="30"
        textAnchor="middle"
        fontSize="18"
        fontWeight="bold"
        fill={selected ? "rgba(249, 246, 246, 0.9)" : numberColor}
        fontFamily="Arial, sans-serif"
        dominantBaseline="middle"
      >
        {name.split(' ')[1]}
      </text>
    )}
  </svg>
);

export default JerseyIcon;